export default __webpack_public_path__ + "static/3-02873b54c40b21f79bea667618c5d327.jpg";